export default __webpack_public_path__ + "static/media/PowerImg.f0f4320a.svg";